export enum SaleListHeaderFilterEnum {
    EMISSION, SALE_ID, PERSON_NAME
}
